
// 模块跳转地址处理
// 把路由里的path处理成指定模块跳转地址
// 截取路由前缀地址,拼接上模块后缀地址
export const pathFormat = (path, module = 'edit', id = 0) => {
  let formatPath = path.substring(0, path.lastIndexOf('/')+1) + module
  if (id) {
    formatPath += `/${id}`
  }
  return formatPath
}

